/* src/app/components/controls/sem-listing-items/sem-listing-items.component.css */
.sem-listing-items-container {
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #ffffff;
  max-height: 300px;
  overflow-y: auto;
  position: relative;
  min-width: 350px;
  width: 100%;
}
.sem-listing-item {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f1f1;
  transition: background-color 0.15s ease;
}
.sem-listing-item:last-child {
  border-bottom: none;
}
.sem-listing-item:hover {
  background-color: #f8f9fa;
}
.sem-listing-item-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  width: 100%;
}
.sem-listing-checkbox {
  margin-right: 8px;
  margin-top: 0;
  margin-bottom: 0;
  cursor: pointer;
  width: 16px;
  height: 16px;
  accent-color: #007bff;
  pointer-events: auto;
  position: relative;
  z-index: 1;
}
.sem-listing-item-title {
  flex: 1;
  color: #333;
  line-height: 1.4;
  word-break: break-word;
}
.select-all-label {
  font-weight: 500;
}
.select-all-title {
  color: #007bff;
  font-weight: 500;
}
.sem-listing-separator {
  height: 1px;
  background-color: #dee2e6;
  margin: 0 12px;
}
.sem-listing-empty {
  padding: 20px 12px;
  text-align: center;
  color: #6c757d;
  font-style: italic;
  font-size: 14px;
}
.sem-listing-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 12px;
  color: #666;
  font-size: 14px;
}
.sem-listing-error {
  padding: 12px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  color: #856404;
  font-size: 14px;
  margin-bottom: 8px;
}
.disabled-field {
  opacity: 0.6;
  background-color: #f8f9fa !important;
}
.disabled-field .sem-listing-checkbox {
  cursor: not-allowed;
}
.disabled-field .sem-listing-item-label {
  cursor: not-allowed;
}
.disabled-field .sem-listing-item:hover {
  background-color: transparent;
}
.sem-listing-checkbox:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}
.sem-listing-items-container::-webkit-scrollbar {
  width: 6px;
}
.sem-listing-items-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.sem-listing-items-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.sem-listing-items-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.is-invalid {
  border-color: #dc3545;
}
.binding-prop-name {
  font-size: 10px;
  color: #6c757d;
  margin: 4px 0 0 0;
  font-family: monospace;
}
.inline-search-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: pointer;
  display: none;
}
/*# sourceMappingURL=sem-listing-items.component.css.map */
